import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { HorizontalSidebarData } from "../../data/json/horizontalSidebar";
import { RootState } from "../../data/redux/store";
import { API_BASE_PATH } from "../../../environment";
import Dropdown from "react-bootstrap/Dropdown";
import {
  deleteNotification,
  getNotificationsByEmployeeId,
  Notification,
  updateNotificationStatus,
} from "../../api/useNotification";
import dayjs from "dayjs";
import { Button, Modal } from "react-bootstrap";
import { Popover } from "antd";
import { useAuthToken } from "../../data/redux/useAuthToken";

const Header = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const name = useSelector((state: RootState) => state.auth.name);
  const email = useSelector((state: RootState) => state.auth.email);
  const role = useSelector ((state: RootState) => state.auth.role);
  const empId = useSelector((state: RootState) => state.auth.employeeId);
  const empToken = useAuthToken();
  const Location = useLocation();
  const [empImage, setEmpImage] = useState("/assets/img/defaultavatar.png");
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const links = [
    { name: "Project ", url: all_routes.projectlist },
    { name: "HR Dashboard", url: "/hr-dashboard" },
    { name: "Employee Directory", url: "/employee-directory" },
    { name: "Attendance", url: all_routes.attendanceadmin },
    { name: "Payroll", url: "/payroll" },
    { name: "Performance", url: all_routes.performanceIndicator },
    { name: "Recruitment", url: "/recruitment" },
    { name: "Training", url: "/training" },
    { name: "Project Gamma", url: "/project-gamma" },
  ];

  // State to store the input value.
  const [searchText, setSearchText] = useState("");

  // Filter links based on the input. This is case-insensitive.
  const filteredLinks = links.filter((link) =>
    link.name.toLowerCase().includes(searchText.toLowerCase())
  );
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {});
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {});
        }
        setIsFullscreen(false);
      }
    }
  };

  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [filteredNotifications, setFilteredNotifications] = useState<
    Notification[]
  >([]);
  const [filter, setFilter] = useState("Today");

  useEffect(() => {
    if (empId) {
      getNotificationsByEmployeeId(empId, empToken).then((data) => {
        setNotifications(data);
      });
    }
  }, [empId]);

  useEffect(() => {
    if (empId && empToken) {
      const fetchImage = async () => {
        try {
          const timestamp = Date.now();
          const res = await fetch(
            `${API_BASE_PATH}/register/employee/${empId}/image?t=${timestamp}`,
            {
              headers: {
                Authorization: `Bearer ${empToken}`,
              },
            }
          );

          if (!res.ok) throw new Error("Image fetch failed");

          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          setEmpImage(url);
        } catch (err) {
          console.error("Failed to load employee image:", err);
          setEmpImage("/assets/img/defaultavatar.png");
        }
      };

      fetchImage();
    }
  }, [empId, empToken]);

  useEffect(() => {
    const now = dayjs();

    let filtered: Notification[] = [];

    switch (filter) {
      case "Today":
        filtered = notifications.filter((n) =>
          dayjs(n.created_at).isSame(now, "day")
        );
        break;
      case "This Week":
        filtered = notifications.filter((n) =>
          dayjs(n.created_at).isSame(now, "week")
        );
        break;
      case "Last Week":
        filtered = notifications.filter((n) => {
          const created = dayjs(n.created_at);
          const lastWeekStart = now.subtract(1, "week").startOf("week");
          const lastWeekEnd = now.subtract(1, "week").endOf("week");
          return (
            created.isAfter(lastWeekStart) && created.isBefore(lastWeekEnd)
          );
        });
        break;
      // case "Last Month":
      //   filtered = notifications.filter((n) =>
      //     dayjs(n.created_at).isSame(now.subtract(1, "month"), "month")
      //   );
      //   break;
    }

    setFilteredNotifications(filtered);
  }, [filter, notifications]);

  const [expandedNotifId, setExpandedNotifId] = useState<number | null>(null);

  const toggleExpand = async (id: number) => {
    if (expandedNotifId === id) {
      setExpandedNotifId(null); // Collapse if already expanded
    } else {
      setExpandedNotifId(id); // Expand new one

      // Find the selected notification
      const selectedNotif = filteredNotifications.find((n) => n.id === id);

      // If unread, mark it as read
      // When marking a notification as read
      if (selectedNotif && selectedNotif.status.toLowerCase() === "unread") {
        try {
          await updateNotificationStatus(
            id,
            selectedNotif.employee_id,
            "read",
            empToken
          );

          // ✅ Update the full notifications list
          setNotifications((prev) =>
            prev.map((n) => (n.id === id ? { ...n, status: "read" } : n))
          );

          // ✅ Also update the current filtered list
          setFilteredNotifications((prev) =>
            prev.map((n) => (n.id === id ? { ...n, status: "read" } : n))
          );
        } catch (err) {
          console.error("Failed to update status to read:", err);
        }
      }
    }
  };
  return (
    <>
      {/* Header */}
      <div className="header">
        <div className="main-header">
          <div className="header-left">
            <Link to={routes.adminDashboard} className="logo">
              <ImageWithBasePath src="assets/img/logo.svg" alt="Togo" />
            </Link>
            <Link to={routes.adminDashboard} className="dark-logo">
              <ImageWithBasePath src="assets/img/logo-white.svg" alt="Togo" />
            </Link>
          </div>
          <Link
            id="mobile_btn"
            onClick={toggleMobileSidebar}
            className="mobile_btn"
            to="#sidebar"
          >
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </Link>
          <div className="header-user">
            <div className="nav user-menu nav-list">
              {/* Updated Search Block with Autocomplete */}
              <div
                className="me-auto d-flex align-items-center"
                id="header-search"
                style={{ position: "relative" }}
              >
                <Link
                  id="toggle_btn"
                  to="#"
                  onClick={handleToggleMiniSidebar}
                  className="btn btn-menubar me-1"
                >
                  <i className="ti ti-arrow-bar-to-left"></i>
                </Link>
                <div className="input-group input-group-flat d-inline-flex me-1">
                  <span className="input-icon-addon">
                    <i className="ti ti-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search in HRMS"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    disabled
                  />
                </div>
                {/* Suggestions Dropdown */}
                {searchText && (
                  <div
                    className="search-suggestions"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      zIndex: "1050",
                      background: "#fff",
                      border: "1px solid #ddd",
                      borderTop: "none",
                    }}
                  >
                    {filteredLinks.length > 0 ? (
                      <ul className="list-group list-group-flush">
                        {filteredLinks.map((link) => (
                          <li key={link.url} className="list-group-item">
                            <Link to={link.url}>{link.name}</Link>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="list-group-item">No links found.</div>
                    )}
                  </div>
                )}
              </div>
              <div
                className="sidebar sidebar-horizontal"
                id="horizontal-single"
              >
                <div className="sidebar-menu">
                  <div className="main-menu">
                    <ul className="nav-menu">
                      <li className="menu-title">
                        <span>Main</span>
                      </li>
                      {HorizontalSidebarData?.map((mainMenu, index) => (
                        <React.Fragment key={`main-${index}`}>
                          {mainMenu?.menu?.map((data, i) => (
                            <li className="submenu" key={`menu-${i}`}>
                              <Link
                                to="#"
                                className={`
                                  ${
                                    data?.subMenus
                                      ?.map((link: any) => link?.route)
                                      .includes(Location.pathname)
                                      ? "active"
                                      : ""
                                  } ${
                                  subOpen === data.menuValue ? "subdrop" : ""
                                }`}
                                onClick={() => toggleSidebar(data.menuValue)}
                              >
                                <i className={`ti ti-${data.icon}`}></i>
                                <span>{data.menuValue}</span>
                                <span className="menu-arrow"></span>
                              </Link>

                              {/* First-level Submenus */}
                              <ul
                                style={{
                                  display:
                                    subOpen === data.menuValue
                                      ? "block"
                                      : "none",
                                }}
                              >
                                {data?.subMenus?.map((subMenu: any, j) => (
                                  <li
                                    key={`submenu-${j}`}
                                    className={
                                      subMenu?.customSubmenuTwo ? "submenu" : ""
                                    }
                                  >
                                    <Link
                                      to={subMenu?.route || "#"}
                                      className={`${
                                        subMenu?.subMenusTwo
                                          ?.map((link: any) => link?.route)
                                          .includes(Location.pathname) ||
                                        subMenu?.route === Location.pathname
                                          ? "active"
                                          : ""
                                      } ${
                                        subsidebar === subMenu.menuValue
                                          ? "subdrop"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        toggleSubsidebar(subMenu.menuValue)
                                      }
                                    >
                                      <span>{subMenu?.menuValue}</span>
                                      {subMenu?.customSubmenuTwo && (
                                        <span className="menu-arrow"></span>
                                      )}
                                    </Link>

                                    {/* Check if `customSubmenuTwo` exists */}
                                    {subMenu?.customSubmenuTwo &&
                                      subMenu?.subMenusTwo && (
                                        <ul
                                          style={{
                                            display:
                                              subsidebar === subMenu.menuValue
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          {subMenu.subMenusTwo.map(
                                            (subMenuTwo: any, k: number) => (
                                              <li key={`submenu-two-${k}`}>
                                                <Link
                                                  className={
                                                    subMenuTwo.route ===
                                                    Location.pathname
                                                      ? "active"
                                                      : ""
                                                  }
                                                  to={subMenuTwo.route}
                                                >
                                                  {subMenuTwo.menuValue}
                                                </Link>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      )}
                                  </li>
                                ))}
                              </ul>
                            </li>
                          ))}
                        </React.Fragment>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/*Notications*/}
              <div className="d-flex align-items-center">
                <div className="me-1">
                  <Popover
                    content={
                      <div
                        style={{
                          backgroundColor: "#000", // black background
                          color: "#fff", // white text
                          padding: "4px 8px",
                          borderRadius: "4px",
                        }}
                      >
                        {isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
                      </div>
                    }
                    trigger="hover"
                    placement="left"
                    overlayInnerStyle={{
                      backgroundColor: "transparent", // remove default white bg
                      boxShadow: "none", // remove extra shadow
                    }}
                  >
                    <Link
                      to="#"
                      onClick={toggleFullscreen}
                      className="btn btn-menubar btnFullscreen"
                    >
                      <i className="ti ti-maximize"></i>
                    </Link>
                  </Popover>
                </div>
                <Dropdown className="me-1 notification_item">
                  <Dropdown.Toggle
                    as={Link}
                    to="#"
                    className="btn btn-menubar position-relative me-1"
                    id="notification_popup"
                  >
                    <i className="ti ti-bell"></i>
                    {filteredNotifications.length > 0 && (
                      <span className="notification-status-dot"></span>
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="dropdown-menu-end notification-dropdown p-3 shadow-lg p-3 mb-5 bg-white rounded"
                    style={{
                      width: "450px",
                    }}
                  >
                    <div className="border-bottom p-0 pb-2 mb-2">
                      <h4 className="notification-title mb-2">
                        Notifications ({filteredNotifications.length})
                      </h4>
                      <div className="d-flex flex-wrap gap-2">
                        {["Today", "This Week", "Last Week"].map((item) => (
                          <button
                            key={item}
                            className={`btn btn-sm ${
                              filter === item
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => setFilter(item)}
                          >
                            {item}
                          </button>
                        ))}
                      </div>
                    </div>
                    {/* Make this part scrollable only */}
                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                      {filteredNotifications.map((notif) => (
                        <div key={notif.id} className="mb-2 border-bottom pb-2">
                          <div
                            className={
                              notif.status.toLowerCase() === "unread"
                                ? "badge bg-danger ms-2"
                                : "badge bg-success ms-2"
                            }
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleExpand(notif.id)}
                          >
                            {notif.title}
                          </div>
                          {expandedNotifId === notif.id && (
                            <div
                              className="mt-2 ps-2"
                              style={{
                                backgroundColor: "#f8f9fa",
                                border: "3px solid #0d6efd",
                                padding: "0.5rem",
                                borderRadius: "0.25rem",
                                transition: "all 0.3s ease",
                              }}
                            >
                              <div>
                                <strong>Message:</strong> {notif.message}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <Dropdown align="end" className="profile-dropdown">
                <Dropdown.Toggle
                  as={Link}
                  to="#"
                  className="d-flex align-items-center"
                  id="profileDropdown"
                >
                  <span className="avatar avatar-sm online">
                    <img
                      src={empImage}
                      alt="Employee Avatar"
                      className="img-fluid rounded-circle"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.onerror = null;
                        target.src = "/assets/img/defaultavatar.png";
                      }}
                    />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow-none p-0 mt-2">
                  <div className="card mb-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center">
                        <span className="avatar avatar-lg me-2 avatar-rounded">
                          <img
                            src={empImage}
                            alt="Employee Avatar"
                            className="img-fluid rounded-circle"
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.onerror = null;
                              target.src = "/assets/img/defaultavatar.png";
                            }}
                          />
                        </span>
                        <div>
                          <h5 className="mb-0">{name}</h5>
                          <h6 className="mb-0">Role : {role}</h6>
                          <p className="fs-12 fw-medium mb-0">{email}</p>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        to={routes.profile}
                      >
                        <i className="ti ti-user-circle me-1"></i>My Profile
                      </Link>
                    </div>
                    <div className="card-footer">
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        to={routes.login}
                      >
                        <i className="ti ti-login me-2"></i>Logout
                      </Link>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <Dropdown align="end" className="mobile-user-menu">
            <Dropdown.Toggle
              as={Link}
              to="#"
              className="nav-link dropdown-toggle"
              id="mobileUserMenu"
            >
              <i className="fa fa-ellipsis-v"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to={routes.profile}>
                My Profile
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={routes.profilesettings}>
                Settings
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={routes.login}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      {/* /Header */}
    </>
  );
};
export default Header;
